import { useState, useEffect } from "react";

// react-router-dom components

// @mui material components
import validator from "validator";
// Material Kit 2 PRO React components
import MKBox from "../../components/MKBox";
import MKButton from "../../components/MKButton";

import apiIRA from "../../api/api.js";
// Image
import axios from "axios";
import constants from "../../common/constants";
import PageLayout from "../../layouts/dashboards";
import AuthenticationCardLayout from "../../layouts/AuthenticationCard/AuthenticationCardLayout";
import AuthenticationMKInput from "../../layouts/AuthenticationCard/AuthenticationMKInput";
import CustomInfoDialog from "../../components/Dialog";
import api from "../../api/api.js";
function Page() {
  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({ user_name: "" });

  /* #region  Authentication MKInput Variables */
  const [isHitEnter, setIsHitEnter] = useState(false);
  const [events, setEvents] = useState(null);
  useEffect(() => {
    if (isHitEnter) {
      handleForgetPassword();
      setIsHitEnter(false);
    }
  }, [isHitEnter]);
  const [mkErrors, setMkErrors] = useState({
    user_name: { state: false, message: "" },
    hash: { state: false, message: "" },
  });
  /* #endregion */

  /* #region CustomInfoDialog  */
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoDialogParams, setInfoDialogParams] = useState({
    title: "",
    messageLine1: "",
    type: "info",
    navigateToUrl: "",
  });
  const handleOpenInfoDialog = (title, msg, type, navigateToUrl) => {
    setInfoDialogParams({
      ...infoDialogParams,
      title: title,
      messageLine1: msg,
      type: type,
      navigateToUrl: navigateToUrl,
    });
    setOpenInfoDialog(true);
  };

  /* #endregion */

  // Function to send post request to recover password API.
  const handleForgetPassword = async () => {
    setIsLoading(true);
    if (!validateFields()) {
      showError();
      setMkErrors({ ...mkErrors, user_name: { state: true, message: "" } });
      return;
    }

    var newJsonObj = {
      email: inputs.user_name,
    };
    await axios
      .post(api.femsRecoverPassword, newJsonObj)
      .then((res) => {})
      .catch(() => {})
      .finally(() => {
        handleOpenInfoDialog(
          "Initiated Password Recovery. ",
          "If the email is registered and valid, you will receive an email shortly. Please check your email for further details",
          "success",
          constants.prefix_url + "login"
        );
        setIsLoading(false);
      });
  };
  const validateFields = () => {
    return validator.isEmail(inputs.user_name);
  };
  const showError = () => {
    handleOpenInfoDialog(
      "Error",
      "Invalid email format. Please try again",
      "error"
    );
    setIsLoading(false);
  };

  return (
    <PageLayout isNoAuthPage={true}>
      <AuthenticationCardLayout title="Password Recovery" loading={isLoading}>
        <AuthenticationMKInput
          inputType="email"
          inputName={"user_name"}
          inputLabel={"Email"}
          inputs={inputs}
          isMandatory={true}
          setInputs={setInputs}
          setEvents={setEvents}
          setIsEnter={setIsHitEnter}
          errorState={mkErrors.user_name.state}
          errorMessage={mkErrors.user_name.message}
          formHelperTextString={
            "   *Email address must be an existing account, otherwise,  please raise a request via JTC SMT for an account "
          }
        />

        <MKBox display="flex" justifyContent="center">
          <MKBox mt={5}>
            <MKButton
              onClick={handleForgetPassword}
              type="submit"
              color="info"
              size="large"
              fullWidth
              disabled={isLoading}
            >
              Submit
            </MKButton>
          </MKBox>
        </MKBox>
      </AuthenticationCardLayout>

      <CustomInfoDialog
        open={openInfoDialog}
        title={infoDialogParams.title}
        messageLine1={infoDialogParams.messageLine1}
        type={infoDialogParams.type}
        navigateToUrl={infoDialogParams.navigateToUrl}
        setOpenDialog={setOpenInfoDialog}
      />
    </PageLayout>
  );
}

export default Page;
